export default __webpack_public_path__ + "static/media/institute-4-min.d7d75179.webp";